import { Link } from 'react-router-dom';
import { T } from './Translator';

function TermsOfService() {
  return (
    <div className="main-content legal">
      <h2><T>Terms of Service</T></h2>
      <p><em><T>Last updated: October 21, 2026</T></em></p>

      <p><T>These Terms of Service ("Terms") govern your use of koplowicz.com (the "Site"), operated by Koplowicz & Sons, a sole proprietorship based in San Francisco, California ("we", "us"). By using the Site you agree to these Terms. If you do not agree, please do not use the Site.</T></p>

      <h3><T>Use of the Site</T></h3>
      <p><T>You may use the Site for lawful purposes only. You agree not to interfere with the Site's operation, attempt to gain unauthorized access to it or its servers, or use automated means to overload it.</T></p>

      <h3><T>Content and intellectual property</T></h3>
      <p><T>The content on the Site, including text, images, logos and code, is owned by or licensed to Koplowicz & Sons and is protected by copyright and other laws. You may view and share links to it, but you may not copy, modify or redistribute it without our permission.</T></p>

      <h3><T>Contact form and chatbot</T></h3>
      <p><T>Messages you send through the contact form or chatbot must not be unlawful, abusive or infringing. Chatbot replies are generated by artificial intelligence and may be inaccurate or incomplete; they are not professional advice, and you should verify anything important.</T></p>

      <h3><T>Translations</T></h3>
      <p><T>Translations are produced automatically by a third-party service and are provided for convenience only. The English text is the authoritative version.</T></p>

      <h3><T>Third-party links and services</T></h3>
      <p><T>The Site may link to or rely on third-party websites and services. We do not control them and are not responsible for their content or practices.</T></p>

      <h3><T>Disclaimer of warranties</T></h3>
      <p><T>The Site is provided "as is" and "as available", without warranties of any kind, express or implied, including fitness for a particular purpose and non-infringement. We do not guarantee that the Site will be uninterrupted or error-free.</T></p>

      <h3><T>Limitation of liability</T></h3>
      <p><T>To the fullest extent permitted by law, Koplowicz & Sons will not be liable for any indirect, incidental, special or consequential damages arising from your use of the Site.</T></p>

      <h3><T>Governing law</T></h3>
      <p><T>These Terms are governed by the laws of the State of California, without regard to conflict-of-law rules.</T></p>

      <h3><T>Changes</T></h3>
      <p><T>We may update these Terms from time to time. Continued use of the Site after a change means you accept the updated Terms.</T></p>

      <h3><T>Contact us</T></h3>
      <p><T>Questions about these Terms? Please use the </T><Link to="/contact"><T>contact form</T></Link><T> or call 707-456-7743. See also our </T><Link to="/privacy"><T>Privacy Policy</T></Link><T>.</T></p>
    </div>
  );
}

export default TermsOfService;
